// The "self-witnessed" rule for the browser (the only copy in src/).
// Same rule as the public.self_witnessed_entries view and
// supabase/functions/_shared/selfWitness.ts: the witness license equals the
// provider's license (trimmed, case-insensitive, both non-empty). Older rows
// without user_license fall back to the provider's license looked up by
// user_id in licenseByUserId, when the caller has it.
const normalize = (value) => (value == null ? '' : String(value).trim().toLowerCase());

export function isSelfWitnessed(record, licenseByUserId = {}) {
  const witness = normalize(record?.secondary_user_license);
  if (!witness) return false;
  const provider = normalize(record.user_license) || normalize(licenseByUserId[record.user_id]);
  return provider !== '' && witness === provider;
}
